import * as React from "react";
const SvgIonReorderTwo = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 11.875a.86.86 0 0 1 .86-.86h10.78a.86.86 0 0 1 0 1.72H4.61a.86.86 0 0 1-.86-.86ZM3.75 8.125a.86.86 0 0 1 .86-.86h10.78a.86.86 0 0 1 0 1.72H4.61a.86.86 0 0 1-.86-.86Z"
      fill="#000"
      fillOpacity={0.4}
    />
  </svg>
);
export default SvgIonReorderTwo;
